const BookMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={22}
      fill="none"
      viewBox="0 0 16 22"
    >
      <path d="M1 21V1H15V21L8 17.31L1 21Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  )
}

export default BookMarkIcon;
